import { AnalyticsBrowser } from '@segment/analytics-next'

import env from '~/env'

function createAnalyticsBrowser(): AnalyticsBrowser | null {
    if (!env.VITE_SEGMENT_HOSTNAME || !env.VITE_SEGMENT_WRITE_KEY) {
        return null
    }

    try {
        return AnalyticsBrowser.load(
            {
                cdnURL: `https://${env.VITE_SEGMENT_HOSTNAME}`,
                writeKey: env.VITE_SEGMENT_WRITE_KEY ?? '',
            },
            {
                integrations: {
                    'Segment.io': {
                        apiHost: `${env.VITE_SEGMENT_HOSTNAME}/v1`,
                    },
                },
            }
        )
    } catch (error) {
        console.error('Failed to initialize analytics', error)
        return null
    }
}

export const analytics = createAnalyticsBrowser()
